var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M4.826 1.406a.875.875 0 0 0-1.234.004L1.413 3.59a.875.875 0 0 0 .004 1.241L4.44 7.816a.5.5 0 0 0 .703-.712L3.67 5.65l1.983-1.983a.516.516 0 0 0 .019-.02l1.477 1.458a.5.5 0 0 0 .703-.711L4.826 1.406Zm.135 1.54-.75-.741L2.21 4.208l.75.74L4.944 2.96a.5.5 0 0 1 .016-.015Zm6.609 5.466a.5.5 0 0 1 .706-.031l1.94 1.776c.18.165.284.4.284.645v2.236a.875.875 0 0 1-.875.875h-2.291a.875.875 0 0 1-.591-.23l-2.08-1.904a.5.5 0 0 1 .675-.738l2.044 1.872H13.5v-2.056l-1.9-1.739a.5.5 0 0 1-.03-.706Zm.308-5.047-2.573 2.43.453.454a.5.5 0 0 1-.707.707l-.473-.474-.817.772.641.642a.5.5 0 0 1-.707.707l-.662-.662-.597.564.391.391a.5.5 0 0 1-.707.707l-.41-.41-3.093 2.921 1.354 1.472 9.261-8.75-1.354-1.471Zm.303-1.147a.37.37 0 0 0-.526-.018l-10.17 9.607a.381.381 0 0 0-.018.534l2.2 2.391a.37.37 0 0 0 .527.018l10.17-9.607a.381.381 0 0 0 .018-.534l-2.2-2.39Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.9b1065660dedd39cf997e3faa42244bc.svg";
export { ForwardRef as ReactComponent };